import { useDispatch } from 'react-redux';
import useFeatureFlags from './useFeaturesFlags';
import useThresholds from './useThresholds';
import useMetricsAndDimensions from './useMetricsAndDimensions';
import useProfileDefault from './useProfileDefault';
import useControlsInit from './useControlsInit';
import { useMemo } from 'react';
import { initTabs } from '@store/dashboards/tabs/actions';
import { useSetAtom } from 'jotai';
import { coreFetchedAtom } from '@src/routers/utils';
import useGlobalFeatureFlags from './useGlobalFeatureFlags';

// TODO: handle errors

const useCore = () => {
  const dispatch = useDispatch();
  const { isFetched: isFeatureFlagsFetched } = useFeatureFlags({});
  const { isFetched: isGlobalFeatureFlagsFetched } = useGlobalFeatureFlags({});
  const { isFetched: isThresholdsFetched } = useThresholds();
  const { isFetched: isMetricsAndDimensionsFetched } = useMetricsAndDimensions();
  const { isFetched: isProfileDefaultFetched } = useProfileDefault();
  const { isFetched: isControlsInitFetched } = useControlsInit({});
  const setCoreFetched = useSetAtom(coreFetchedAtom);

  const isFetched =
    isThresholdsFetched &&
    isFeatureFlagsFetched &&
    isGlobalFeatureFlagsFetched &&
    isMetricsAndDimensionsFetched &&
    isProfileDefaultFetched &&
    isControlsInitFetched;

  useMemo(() => {
    if (isFetched) {
      dispatch(initTabs());
      setCoreFetched(true);
    }
  }, [isFetched]);
};

export default useCore;
